import { ControlType } from './ControlType';

/**
 * A data type (bean) for a UI Input Element.
 */
export class ControlElement {
    displayName: string;
    x: number;
    y: number;
    type: ControlType;

    /**
     * Constructor
     * @param displayName the display name of the shape (what the user specifies).
     * @param x x position
     * @param y y position
     * @param type type of control
     */
    constructor(displayName:string,x: number, y: number, type: ControlType) {
        this.displayName = displayName
        this.x = x;
        this.y = y;
        this.type = type;
    }
}